import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: process.env.VUE_APP_SERVER_BACKEND || "http://127.0.0.1:8000/api",
    headers: {
        'Content-Type': 'application/json',
    },
});


// Interceptor para incluir el token en las solicitudes
axiosInstance.interceptors.request.use(
    (config) => {
        // Obtener el token del localStorage o del store (dependiendo de cómo lo gestiones)
        const token = localStorage.getItem('userToken'); // Cambia según tu gestión del token
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        // Manejo de errores al configurar la solicitud
        return Promise.reject(error);
    }
);



export default axiosInstance; 